var _defs, _path, _path2, _path3, _circle, _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBi = function SvgBi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 300"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__a",
    id: "bi_svg__f",
    x: 250,
    y: 106
  }), /*#__PURE__*/React.createElement("g", {
    id: "bi_svg__a",
    fill: "#1eb53a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bi_svg__e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bi_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bi_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bi_svg__b",
    d: "M0-20V0h20",
    transform: "rotate(30 0 -20)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__b",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__c",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__c",
    transform: "rotate(240)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__d",
    transform: "rotate(180)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__e",
    fill: "#ce1126",
    transform: "scale(.82)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h500L0 300h500z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1eb53a",
    d: "M0 0v300L500 0v300z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 40,
    d: "m0 0 500 300m0-300L0 300"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 150,
    r: 85,
    fill: "#fff"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__f"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__f",
    transform: "rotate(120 250 150)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bi_svg__f",
    transform: "rotate(240 250 150)"
  })));
};
export default SvgBi;